module.exports = __webpack_public_path__ + "img/case.6c62a043.png";